import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subject } from "rxjs";
import {
    TenantLastActive,
    GetInactiveTenantsQueryResult,
    GetInactiveTenantsRequest,
    PeriodRange,
    SessionApi,
} from "../api/proxies";
import { ClipboardUtils, PagedListingComponentBase } from "@vui";
import { NotifyService } from "@ui/notify";
import { PageEvent } from "@angular/material/paginator";
import { SessionHelper } from "../tools/utils";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";

@Component({
    selector: "inactive-tenants",
    styleUrls: ["./inactive-tenants.component.scss"],
    templateUrl: "./inactive-tenants.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InactiveTenantsComponent extends PagedListingComponentBase<TenantLastActive> implements OnInit, OnDestroy {
    @ViewChild(MatSort) sort: MatSort;

    public dataSource: MatTableDataSource<TenantLastActive> = new MatTableDataSource();

    private _unsubscribeAll = new Subject();

    pageSize = 20;
    loading: boolean = false;
    selectedPeriod: number;
    baseUrl: string;
    period: PeriodRange;

    public displayedColumns: string[] = ["id", "name", "email", "phoneNumber", "lastAccess"];

    constructor(injector: Injector, private _notifyService: NotifyService, private _sessionApi: SessionApi) {
        super(injector, "Total de clientes inativos", "Nenhum cliente inativo encontrado");

        // Initialize the data source with an empty array
        this.dataSource.data = [];
    }

    ngOnInit(): void {
        this.refresh();
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    selectPeriod() {
        this.period = SessionHelper.PeriodConverter(this.selectedPeriod);
        const request: GetInactiveTenantsRequest = new GetInactiveTenantsRequest();
        request.periodRange = this.period;
        request.maxResultCount = this.pageSize;
        request.skipCount = 0;

        this.getInactiveClients(request, 0);
    }

    copy(text: any) {
        ClipboardUtils.copyText(text);
        this._notifyService.info("Copiado para a area de transferencia");
    }

    exportSpreadsheet() {
        const request: GetInactiveTenantsRequest = new GetInactiveTenantsRequest();
        request.periodRange = new PeriodRange(this.period);

        this._sessionApi.exportInactive(request).subscribe(
            (blob: any) => {
                const blobUrl = URL.createObjectURL(blob.data);
                const anchor = document.createElement("a");
                anchor.href = blobUrl;
                anchor.download = "clientes-inativos.xlsx"; // Você pode optar por extrair o nome se ele vier nos headers
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                window.URL.revokeObjectURL(blobUrl);
            },
            (error) => {
                this._notifyService.error("Ocorreu um erro ao exportar o arquivo.");
            },
            () => {
                this.loading = false;
            }
        );
    }

    onPageChanged(pageEvent: PageEvent) {
        this.getDataPage(pageEvent.pageIndex);
    }

    onSortChanged(sort: Sort): void {
        if (!sort.active || sort.direction === "") {
            return;
        }

        const sortingParam = `${sort.active} ${sort.direction.toUpperCase()}`;

        const request: GetInactiveTenantsRequest = new GetInactiveTenantsRequest();
        request.periodRange = this.period;
        request.skipCount = 0;
        request.maxResultCount = this.pageSize;

        request.sorting = sortingParam;

        this.getInactiveClients(request, 0);
    }

    getInactiveClients(request: GetInactiveTenantsRequest, pageNumber: number) {
        this.loading = true;
        request.sorting = !request.sorting ? "LastAccess" : request.sorting;
        this._sessionApi.inactive(request).subscribe(
            (result: GetInactiveTenantsQueryResult) => {
                if (result && result.items.length) {
                    this.dataSource.data = result.items;
                    this.showPaging(result, pageNumber);
                }
            },
            () => {
                this._notifyService.error("Ocorreu um erro ao buscar clientes inativos.");
            },
            () => {
                this.loading = false;
            }
        );
    }

    protected list(request: GetInactiveTenantsRequest, pageNumber: number, finishedCallback: Function): void {
        this.period = new PeriodRange(SessionHelper.PeriodConverter(this.selectedPeriod));
        request.periodRange = new PeriodRange(this.period);
        this.getInactiveClients(request, pageNumber);
    }

    protected delete(entity: TenantLastActive): void {
        throw new Error("Method not implemented.");
    }
}
